<template>
  <section>
    <question v-if="display"></question>
  <!-- Preferences View -->
  <div>
      <fieldset>
        <div hidden>
          <span id="new-window">Read more about it. This link opens in a new window.</span>
        </div>

        <div class="col-sm-6" v-if="preferences.length > 0">
          <div class="checkbox c-checkbox"
            v-for="index in middleIndex"
            v-bind:key="index - 1">
            <label v-if="isGeneralPreference(index - 1)">
              <input type="checkbox"
                :id="preferences[index - 1].id"
                :value="preferences[index - 1].id"
                v-model="preferences[index - 1].isSelected"
                :disabled="isReadOnly"
                @change="onChangeSelectImpactPreference">
              <span class="fa fa-check"></span>
              Where Calvert Impact Capital sees the most need and opportunity
            </label>

            <label v-if="!isGeneralPreference(index - 1) && !isOtherPreference(index - 1)">
              <input type="checkbox"
                :id="preferences[index - 1].id"
                :value="preferences[index - 1].id"
                v-model="preferences[index - 1].isSelected"
                :disabled="isReadOnly"
                @change="onChangeSelectImpactPreference">
              <span class="fa fa-check"></span>
              {{ preferences[index - 1].preferenceText }}
            </label>

            <a v-bind:href="preferences[index - 1].url"
              target="_blank" rel="noopener" aria-describedby="new-window"
              class="checkbox-link" title="Read more..."
              v-if="!isGeneralPreference(index - 1) && !isOtherPreference(index - 1)">
              <em class="fa fa-external-link" aria-hidden></em>
            </a>
          </div>
        </div>

        <div class="col-sm-6" v-if="preferences.length > 0">
          <div class="checkbox c-checkbox"
            v-for="index in (preferences.length - middleIndex)"
            v-bind:key="index + middleIndex - 1">
            <label v-if="isGeneralPreference(index + middleIndex - 1)">
              <input type="checkbox"
                :id="preferences[index - 1].id"
                :value="preferences[index - 1].id"
                v-model="preferences[index - 1].isSelected"
                :disabled="isReadOnly"
                @change="onChangeSelectImpactPreference">
              <span class="fa fa-check"></span>
              Where Calvert Impact Capital sees the most need and opportunity
            </label>

            <label v-if="!isGeneralPreference(index + middleIndex - 1) && !isOtherPreference(index + middleIndex - 1)">
              <input type="checkbox"
                :id="preferences[(index + middleIndex) - 1].id"
                :value="preferences[(index + middleIndex) - 1].id"
                v-model="preferences[(index + middleIndex) - 1].isSelected"
                :disabled="isReadOnly"
                @change="onChangeSelectImpactPreference">
              <span class="fa fa-check"></span>
              {{ preferences[(index + middleIndex) - 1].preferenceText }}
            </label>

            <a v-bind:href="preferences[index + middleIndex - 1].url"
              target="_blank" rel="noopener" aria-describedby="new-window"
              class="checkbox-link" title="Read more..."
              v-if="!isGeneralPreference(index + middleIndex - 1) && !isOtherPreference(index + middleIndex - 1)">
              <em class="fa fa-external-link" aria-hidden></em>
            </a>
          </div>
        </div>

      </fieldset>
      <fieldset class="extra-option">
        <div class="col-sm-6">
          <RestrictedSingleInput
            @inputUpdated="selectOtherPreference"
            :dual="true"
            :input="other"
            :limit="50"
            :warningLimit="29"
            fieldLabel="Other"
            instructionsLabel="Make sure your text doesn't exceed 50 characters."
            :placeholderText="'Enter your preference here...'"
            :isDisabled="isReadOnly" />
          </div>
        </fieldset>

      <div class="row">
        <div class="col-md-2">
          <button type="submit" class="btn btn-default btn-lg button-submit" :disabled="isReadOnly" @click="showConfirmationModal">Submit</button>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

import {
  SET_ERRORS_MODAL_INFO,
  SHOW_ERRORS_MODAL,
  SHOW_QUESTION_MODAL,
  HIDE_QUESTION_MODAL,
} from '@/store/mutation-types';

import { logAction, logglyTags } from '@/util';
import logActions from '@/data/static/logActions';
import { Constants } from '@/data/static/constants';
import Question from '@/components/modals/Question';

import RestrictedSingleInput from '@/components/formControls/RestrictedSingleInput';

export default {
  props: ['accountId', 'primaryInvestor'],
  data() {
    return {
      addPreferences: [],
      removePreferences: [],
      preferences: [],
      middleIndex: 0,
      other: '',
      otherText: null,
      otherTextId: null,
      reservedPreferenceCodes: null,
    };
  },
  async beforeMount() {
    await this.checkUserStatus();
    this.hideQuestionModal();
    this.initialize();
  },
  methods: {
    ...mapActions('account', ['getAccountImpactPreferences']),
    ...mapActions('impactPreferences',
      ['getImpactPreferences',
        'getSeparatedDisplayedAndNonDisplayedPreferencesInvestor']),
    ...mapActions('home', ['getUserStatus']),
    ...mapActions('account', ['updateAccountImpactPreferences']),
    ...mapMutations('errors', {
      showErrorsModal: SHOW_ERRORS_MODAL,
      setErrorsModalInfo: SET_ERRORS_MODAL_INFO,
    }),
    ...mapMutations('question', {
      hideQuestionModal: HIDE_QUESTION_MODAL,
      showQuestionModal: SHOW_QUESTION_MODAL,
    }),
    checkUserStatus() {
      if (!this.hasBeenCreatedAccount) {
        this.$router.push({ name: 'AccountSummary' });
      }

      return this.getUserStatus({
        accountId: this.activeAccount.id,
      }).then(({ status, needs, hasFundingSource }) => {
        if (status === 'suspended') {
          this.$router.push({ name: 'AccountSuspended' });
        } else if (status === 'retry') {
          this.$router.push({ name: 'AccountCreation' });
        } else if (status === 'document') {
          this.$router.push({ name: 'DocumentUpload' });
        } else if (needs.includes('FUNDING_SOURCE') && !hasFundingSource) {
          this.$router.push({ name: 'AddFundingSource' });
        } else if (needs.includes('NOTE')) {
          this.$router.push({ name: 'PurchaseNote', query: { first: 1 } });
        }
        return true;
      });
    },
    async initialize() {
      try {
        const [accountImpactPreferences, impactPreferences] = await Promise.all([
          this.getAccountImpactPreferences(this.accountId),
          this.getImpactPreferences(),
        ]);
        this.accountImpactPreferencesIds = accountImpactPreferences.map(aip => aip.id);
        this.impactPreferencesIds = impactPreferences.map(ip => ip.id);

        const {
          displayedPreferences,
          nonDisplayedPreferences,
        } = await this.getSeparatedDisplayedAndNonDisplayedPreferencesInvestor({
          impactPreferences,
          accountImpactPreferences,
        });

        this.preferences = displayedPreferences.concat(nonDisplayedPreferences);

        this.reservedPreferenceCodes = { ...this.reservedImpactPreferenceCodes };

        this.setOtherText({
          displayedPreferences: this.preferences,
          reservedPreferenceCodes: this.reservedPreferenceCodes,
        });

        this.middleIndex = Math.trunc(this.preferences.length / 2) + 1;
      } catch (error) {
        this.setErrorsModalInfo(['Something went wrong. Please try again.']);
        this.showErrorsModal();

        logAction({
          user: this.primaryInvestor.id,
          level: 'error',
          action: logActions.VIEW_INVESTOR_IMPACT_PREFERENCES.name,
          message: error.message,
          stack: error.stack,
          tags: [logglyTags.auth0],
        });
      } finally {
        this.$emit('loaded');
      }
    },
    isGeneralPreference(index) {
      return (
        this.reservedPreferenceCodes !== null &&
        this.preferences[index] !== undefined &&
        this.preferences[index].code === this.reservedPreferenceCodes.general
      );
    },
    isOtherPreference(index) {
      return (
        this.reservedPreferenceCodes !== null &&
        this.preferences[index] !== undefined &&
        this.preferences[index].code === this.reservedPreferenceCodes.other
      );
    },
    selectOtherPreference(text) {
      if (this.isReadOnly) return;
      this.other = text.trim();
      this.preferences = this.preferences.map((preference) => {
        if (preference.id === 2) {
          this.otherText = preference.otherText;
          this.otherTextId = preference.id;
          return {
            ...preference,
            isSelected: text.trim() !== '',
            otherText: text.trim(),
          };
        }
        return preference;
      });
    },
    setOtherText({ displayedPreferences, reservedPreferenceCodes }) {
      const otherPreference = displayedPreferences.find(
        preference => preference.code === reservedPreferenceCodes.other,
      );

      if (!otherPreference) return;

      const { otherText } = otherPreference;

      if (otherText) {
        const length = otherText.length > 50 ? 50 : otherText.length;
        this.other = otherText.substring(0, length);
      }
    },
    showConfirmationModal() {
      if (this.isReadOnly) return;
      this.showQuestionModal({
        title: Constants.investorPreferences.modalTitle,
        question: Constants.investorPreferences.modalQuestion,
        yesButtonText: Constants.investorPreferences.modalYesButtonText,
        method: this.saveInvestorImpactPreferences,
      });
    },
    onChangeSelectImpactPreference(event) {
      if (this.isReadOnly) return;
      const { checked, value: preferenceId } = event.target;
      const parsedPreferenceId = Number(preferenceId);
      const belongsToAccount = this.accountImpactPreferencesIds.includes(parsedPreferenceId);

      if (checked && !belongsToAccount) {
        this.addPreferences.push(parsedPreferenceId);
        this.removePreferences = this.removePreferences.filter(rp => rp !== parsedPreferenceId);
      } else if (!checked && belongsToAccount) {
        this.removePreferences.push(parsedPreferenceId);
        this.addPreferences = this.addPreferences.filter(rp => rp !== parsedPreferenceId);
      }
    },
    async saveInvestorImpactPreferences() {
      this.hideQuestionModal();
      this.loading = true;
      return this.updateAccountImpactPreferences({
        accountId: this.accountId,
        payload: {
          addPreferences: this.addPreferences,
          removePreferences: this.removePreferences,
          otherText: this.otherText,
          otherId: this.otherTextId,
        },
      })
      .then(async () => {
        this.addPreferences = [];
        this.removePreferences = [];
        await this.initialize().then(() => {
          this.loading = false;
          this.$emit('saved');
        });
      })
      .catch((error) => {
        this.loading = false;
        this.setErrorsModalInfo(['Something went wrong. Please try again.']);
        this.showErrorsModal();
        logAction({
          message: 'Something went wrong while trying to save investor preferences',
          stack: error.stack || 'NA',
          level: 'error',
        });
      });
    },
  },
  computed: {
    ...mapState('app', ['activeAccount', 'user']),
    ...mapState('question', ['display']),
    ...mapState('errors', ['isVisibleErrorsModal']),
    ...mapState('app', [
      'reservedImpactPreferenceCodes',
    ]),
    ...mapGetters('app', [
      'hasBeenCreatedAccount',
    ]),
    isReadOnly() {
      return this.user && this.user.userType === 'READ_ONLY';
    },
    selectedPreferences() {
      return this.preferences
        .filter(preference => preference.isSelected)
        .map(preference => ({
          id: preference.id,
          otherText: preference.otherText,
        }));
    },
  },
  watch: {
    other(value) {
      this.selectOtherPreference(value);
    },
  },
  components: {
    question: Question,
    RestrictedSingleInput,
  },
};
</script>

<style scoped>
.panel-title {
  position: relative;
  width: 100%;
  padding-bottom: 20px;
  border-bottom: 1px dashed #eee;
}

.checkbox + .checkbox {
  margin-top: 20px;
}

.checkbox {
  cursor: default;
}

.checkbox label {
  position: relative;
  padding-left: 40px;
  cursor: pointer;
  display: inline-block;
}

.c-checkbox:hover span {
  border-color: #cccccc;
}

.c-checkbox label:hover span {
  border-color: #137d8f;
}

.c-checkbox input:focus + span {
  border-color: #137d8f;
}

.checkbox .fa-check {
  position: absolute;
  margin: 0;
  left: 0;
}

.checkbox-disabled {
  outline: 1px solid red;
}

.checkbox p {
  margin-left: 40px;
  display: inline-block;
  cursor: text;
  color: #929292;
}

.checkbox-link {
  margin-left: 4px;
  display: inline-block;
  color: #137d8f;
  opacity: 0.75;
  transition: color 0.4s ease-in-out;
}

.checkbox-link:hover,
.checkbox-link:focus {
  opacity: 1;
}

.extra-option {
  padding: 20px 0;
}

.extra-option textarea {
  resize: vertical;
}

.empty-state {
  margin: 0 auto;
  max-width: 740px;
  text-align: center;
  padding: 40px 0;
}

.empty__icon {
  font-size: 120px;
}

.empty__title {
  font-size: 28px;
  margin-bottom: 20px;
}
form.row {
  padding: 0 15px;
}
fieldset {
  padding: 12px 0;
  margin-bottom: 12px;
}
input.warning {
  border-color: #ffd814;
}
input.warning-error {
  border-color: #ff8116;
}
</style>



// WEBPACK FOOTER //
// Preferences.vue?d1c45ba6